import { CAMERA } from '../config/constants';
import { regionAround } from '../lib/geo';
import { mapController } from '../map/mapController';
import { useAppStore } from '../store/appStore';
import { IconButton } from './ui';

/**
 * MapControlsView: center on user (disabled until a fix exists), layer picker,
 * and the gauge visibility toggle with its 3 second toast.
 */
export function MapControls() {
  const userLocation = useAppStore((s) => s.userLocation);
  const showAllGauges = useAppStore((s) => s.showAllGauges);
  const setShowAllGauges = useAppStore((s) => s.setShowAllGauges);
  const layerPickerOpen = useAppStore((s) => s.layerPickerOpen);
  const setLayerPickerOpen = useAppStore((s) => s.setLayerPickerOpen);
  const showToast = useAppStore((s) => s.showToast);

  const centerOnUser = () => {
    if (!userLocation) return;
    mapController.showRegion(regionAround(userLocation, CAMERA.centerOnUserMeters));
  };

  const toggleGauges = () => {
    const next = !showAllGauges;
    setShowAllGauges(next);
    showToast(next ? 'Non-flooding and unknown state gauges displayed.' : 'Non-flooding and unknown state gauges now hidden.');
  };

  return (
    <div className="map-controls">
      <IconButton label="Center on my location" onClick={centerOnUser} disabled={!userLocation} className="map-control">
        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21 3L3 10.5l8 2.5 2.5 8L21 3z" fill="currentColor" />
        </svg>
      </IconButton>
      <IconButton label="Map layers" onClick={() => setLayerPickerOpen(!layerPickerOpen)} active={layerPickerOpen} className="map-control">
        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3l9 5-9 5-9-5 9-5z" fill="currentColor" />
          <path d="M3 12.5l9 5 9-5M3 16.5l9 5 9-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      </IconButton>
      <IconButton
        label={showAllGauges ? 'Hide non-flooding gauges' : 'Show all gauges'}
        onClick={toggleGauges}
        active={showAllGauges}
        className="map-control"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ opacity: showAllGauges ? 1 : 0.75 }}>
          <path d="M4 18a8 8 0 1 1 16 0" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M12 18l4-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="12" cy="18" r="1.6" fill="currentColor" />
        </svg>
        {!showAllGauges ? <span className="map-control-slash" aria-hidden="true" /> : null}
      </IconButton>
    </div>
  );
}
